import { render, staticRenderFns } from "./incident-listing.vue?vue&type=template&id=b0927a6a"
import script from "./incident-listing.vue?vue&type=script&lang=js"
export * from "./incident-listing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports